/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Field_Session_TimeInputs */

const vi_stocktake_field_session_time = /** @type {(inputs: Stocktake_Field_Session_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên kiểm`)
};

/**

* @param {Stocktake_Field_Session_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_field_session_time = /** @type {((inputs?: Stocktake_Field_Session_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Field_Session_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_field_session_time(inputs)
});